var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorPlug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.75 70.75C38.5 70.75 37.25 70.25 36.25 69.25C34.25 67.25 34.25 64.25 36.25 62.25L48.75 49.75C50.75 47.75 53.75 47.75 55.75 49.75C57.75 51.75 57.75 54.75 55.75 56.75L43.25 69.25C42.25 70.25 41 70.75 39.75 70.75Z",
    fill: "#B4B4B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 85.25C52.75 85.25 51.5 84.75 50.5 83.75C48.5 81.75 48.5 78.75 50.5 76.75L63 64.25C65 62.25 68 62.25 70 64.25C72 66.25 72 69.25 70 71.25L57.5 83.75C56.5 84.75 55.25 85.25 54 85.25Z",
    fill: "#B4B4B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 118.75C5 118.75 3.75 118.25 2.75 117.25C0.75 115.25 0.75 112.25 2.75 110.25L15.5 97.5C17.5 95.5 20.5 95.5 22.5 97.5C24.5 99.5 24.5 102.5 22.5 104.5L9.75 117.25C8.75 118.25 7.5 118.75 6.25 118.75Z",
    fill: "#B4B4B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.25 23.75C100 23.75 98.75 23.25 97.75 22.25C95.75 20.25 95.75 17.25 97.75 15.25L110.5 2.5C112.5 0.5 115.5 0.5 117.5 2.5C119.5 4.5 119.5 7.5 117.5 9.5L104.75 22.25C103.75 23.25 102.5 23.75 101.25 23.75Z",
    fill: "#B4B4B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.25 18.75C93.5 11 81 11 73.25 18.75L59.25 32.75L87.25 60.75L101.25 46.75C109 39 109 26.5 101.25 18.75Z",
    fill: "#F0F0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.25 65.75C86 65.75 84.75 65.25 83.75 64.25L55.75 36.25C54.75 35.25 54.25 34 54.25 32.75C54.25 31.5 54.75 30.25 55.75 29.25L69.75 15.25C74.5 10.5 80.5 8 87.25 8C93.75 8 100 10.5 104.75 15.25C114.5 25 114.5 40.5 104.75 50.25L90.75 64.25C89.75 65.25 88.5 65.75 87.25 65.75ZM66 32.75L87 53.75L97.5 43.25C103.25 37.5 103.25 28 97.5 22.25C94.75 19.5 91 18 87 18C83 18 79.25 19.5 76.5 22.25L66 32.75Z",
    fill: "#B4B4B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 101.25C11 93.5 11 81 18.75 73.25L32.75 59.25L60.75 87.25L46.75 101.25C39 109 26.5 109 18.75 101.25Z",
    fill: "#B4B4B4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.75 111.75C26.25 111.75 20 109.25 15.25 104.5C5.5 94.75 5.5 79.25 15.25 69.5L29.25 55.5C31 53.75 34.25 53.75 36.25 55.5L64.25 83.5C65.25 84.5 65.75 85.75 65.75 87C65.75 88.25 65.25 89.5 64.25 90.5L50.25 104.5C45.75 109.25 39.5 111.75 32.75 111.75ZM32.75 66L22.25 76.5C16.5 82.25 16.5 91.75 22.25 97.5C25 100.25 28.75 101.75 32.75 101.75C36.75 101.75 40.5 100.25 43.25 97.5L53.75 87L32.75 66Z",
    fill: "#DCDCDC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8885 42.2223L14.8145 42.2223",
    stroke: "#B4B4B4",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5922 31.1111L16.2959 14.8148",
    stroke: "#B4B4B4",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9629 27.4074L42.9629 13.3334",
    stroke: "#B4B4B4",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1115 74.0741L105.186 74.0741",
    stroke: "#B4B4B4",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4078 85.1853L103.704 101.482",
    stroke: "#B4B4B4",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0371 88.8889L77.0371 102.963",
    stroke: "#B4B4B4",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPlug);
export default __webpack_public_path__ + "static/media/error_plug.b270a3c8508c6c8825cc3916c756720b.svg";
export { ForwardRef as ReactComponent };